import { axiosClient } from '@services/clients'

export async function getProviders() {
  const {
    data: { result },
  } = await axiosClient('/providers')

  return result
}
